export function reconnectDelay(attempt: number, random = Math.random()): number {
  const base = Math.min(15_000, 1_000 * 2 ** Math.max(0, attempt));
  return Math.round(base * (0.8 + Math.max(0, Math.min(1, random)) * 0.4));
}
